import React from "react";
import { clsx } from "clsx";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: "text" | "circular" | "rectangular";
    width?: string | number;
    height?: string | number;
}

export const Skeleton: React.FC<SkeletonProps> = ({
    variant = "text",
    width,
    height,
    className,
    style,
    ...props
}) => (
    <div
        aria-hidden
        className={clsx(
            "animate-pulse bg-neutral-border/80 dark:bg-white/10",
            variant === "circular" && "rounded-full",
            variant === "text" && "rounded-md h-4",
            variant === "rectangular" && "rounded-mz-lg",
            className,
        )}
        style={{ width, height: height ?? (variant === "circular" ? width : undefined), ...style }}
        {...props}
    />
);
